/**
 * Tombstone thumbnails for files removed from the Bin for good live under
 * `images/deleted/<id>-<deletedAt><ext>` (see lib/server/file-store.js).
 */

const DELETED_THUMBS_PREFIX = 'images/deleted/';

function normalizePath(url) {
    return String(url || '').replace(/^\/+/, '');
}

/** True for the thumbnail a tombstone keeps after its file was removed for good. */
export function isDeletedImageUrl(url) {
    return normalizePath(url).startsWith(DELETED_THUMBS_PREFIX);
}

export function deletedAtFromUrl(url) {
    const match = normalizePath(url).match(/-(\d{10,})\.[a-z0-9]+$/i);
    return match ? Number(match[1]) : null;
}
